/**
 * Promotions Module
 *
 * Handles promotion functionality including:
 * - Form validation
 * - Discount type switching (percentage vs fixed)
 */

import { $, ready } from '../utils/dom.js';

// =============================================================================
// Promotion Form
// =============================================================================

/**
 * Initialize promotion form validation
 */
function initPromotionFormValidation() {
    const form = $('#promotion-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
        const name = $('#name')?.value.trim();
        const discountType = $('#discount_type')?.value;
        const discountValue = $('#discount_value')?.value;
        const startDate = $('#start_date')?.value;
        const endDate = $('#end_date')?.value;

        if (!name) {
            alert('Please enter a promotion name');
            e.preventDefault();
            return;
        }

        if (!discountType) {
            alert('Please select a discount type');
            e.preventDefault();
            return;
        }

        if (!discountValue || parseFloat(discountValue) <= 0) {
            alert('Please enter a valid discount value');
            e.preventDefault();
            return;
        }

        if (discountType === 'percentage' && parseFloat(discountValue) > 100) {
            alert('Percentage discount cannot exceed 100%');
            e.preventDefault();
            return;
        }

        if (startDate && endDate && new Date(startDate) >= new Date(endDate)) {
            alert('Start date must be before end date');
            e.preventDefault();
            return;
        }
    });
}

/**
 * Initialize discount type switcher
 */
function initDiscountTypeSwitcher() {
    const discountTypeSelect = $('#discount_type');
    if (!discountTypeSelect) return;

    const discountValue = $('#discount_value');
    const currencySymbol = $('#currency-symbol');
    const percentageSymbol = $('#percentage-symbol');

    function updateDiscountUI(type) {
        if (!discountValue) return;

        switch(type) {
            case 'percentage':
                discountValue.placeholder = '0';
                discountValue.max = '100';
                discountValue.classList.remove('pl-7');
                discountValue.classList.add('pr-7');
                if (currencySymbol) currencySymbol.classList.add('hidden');
                if (percentageSymbol) percentageSymbol.classList.remove('hidden');
                break;
            case 'fixed_amount':
                discountValue.placeholder = '0.00';
                discountValue.max = '';
                discountValue.classList.add('pl-7');
                discountValue.classList.remove('pr-7');
                if (currencySymbol) currencySymbol.classList.remove('hidden');
                if (percentageSymbol) percentageSymbol.classList.add('hidden');
                break;
            case 'free_shipping':
                // Hide discount value for free shipping
                const container = $('#discount-value-container');
                if (container) container.classList.add('hidden');
                break;
        }
    }

    discountTypeSelect.addEventListener('change', function(e) {
        updateDiscountUI(e.target.value);
    });

    // Initial update
    updateDiscountUI(discountTypeSelect.value);
}

// =============================================================================
// Auto-Initialization
// =============================================================================

function initPromotions() {
    initPromotionFormValidation();
    initDiscountTypeSwitcher();
}

ready(initPromotions);

export default {
    initPromotionFormValidation,
    initDiscountTypeSwitcher
};
